module.exports = __webpack_public_path__ + "img/phone.4dc2e2c4.svg";